import React, { useEffect, useState } from 'react';
import { Row, Input, message } from 'antd';
import { SearchOutlined, RightOutlined, DownOutlined } from '@ant-design/icons';
import { somenteNumeros } from '../../helpers/utils';
import { IniciarAtendimentoConsulta } from './IniciarAtendimentoConsulta/index';

import {
  getConsultasExternas,
  postIniciarAtendimentoConsultaExterna,
} from '../../services';
import { useAuth } from '../../hooks/auth';
import { formatDuration } from '../../helpers/formatarDataFila';
import * as B from './ButtonFinalizarAtendimentoExterno/index';
import * as S from './styles';

export function TableCustom({ dateRange }) {
  const { temPermissao } = useAuth();
  const [dataTable, setDataTable] = useState([]);
  const [dataRender, setDataRender] = useState([]);
  const [columnsTable, setColumnsTable] = useState([]);
  const [inputBusca, setInputBusca] = useState('');
  const [isAdm, setIsAdm] = useState(false);
  const [consultaAtendimento, setConsultaAtendimento] = useState();
  const [inicializarTela, setInicializarTela] = useState();

  const formatarTempoFila = (value = '') => {
    if (value.length > 16) {
      return formatDuration(value);
    }
    return value.replace(/(\d{2}):(\d{2}):(\d{2}).(\d+)/g, '$1:$2:$3');
  };

  const finalizarAtendimento = () => {
    // Apenas para sempre que finalizar renderizar a tela
    setInicializarTela(true);
    message.success('Consulta registrada com sucesso!');
  };

  const retornaStatus = (record, index) => {
    if (record?.status === 'Finalizar') {
      return (
        <B.ButtonFinalizarAtendimentoExterno
          funcOk={() => finalizarAtendimento()}
          dadosMotorista={record}
        />
      );
    }

    return <S.LabelStatus key={index}>{record?.status}</S.LabelStatus>;
  };
  const columns = [
    {
      title: 'Solicitação',
      dataIndex: 'solicitacao',
      key: 'solicitacao',
      align: 'center',
    },
    {
      title: 'Motorista',
      dataIndex: 'nome',
      key: 'nome',
      align: 'center',
    },
    {
      title: 'CPF',
      dataIndex: 'cpf',
      key: 'cpf',
      align: 'center',
    },
    {
      title: 'Tempo de fila',
      dataIndex: 'fila',
      key: 'tempofila',
      align: 'center',
      render: (_, record) => formatarTempoFila(record?.fila),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (_, record, index) => retornaStatus(record, index),
    },
  ];

  const statusAtendimento = temAtendimento =>
    temAtendimento ? 'Finalizar' : 'A iniciar';

  const initialData = async () => {
    try {
      const response = await getConsultasExternas();

      const data = response.data.map(item => ({
        key: item?.idConsultaSolicitacao,
        id: item?.idConsultaSolicitacao,
        solicitacao: item?.idIntegracaoSolicitacao,
        nome: item?.nomeMotorista,
        cpf: item?.cpfMotorista,
        fila: item?.tempoFila || '00:00:00',
        status: statusAtendimento(item?.temAtendimento),
      }));
      setDataTable(data);
    } catch (error) {
      return message.error(
        error?.response?.detail || 'Erro ao carregar lista de Solicitações.'
      );
    }
  };

  const inputFilter = () => {
    const busca = dataTable.filter(item => {
      const concatenado = item?.solicitacao
        ?.concat(item?.nome)
        ?.concat(somenteNumeros(item?.cpf))
        ?.concat(item?.cpf);

      return concatenado?.toLowerCase().includes(inputBusca?.toLowerCase());
    });

    return setDataRender(busca);
  };

  const formatColumns = () => {
    const newCols = columns.splice(0, 6);

    return setColumnsTable(newCols);
  };

  const atualizaStatusConsultaFinalizar = idxConsulta => {
    const itens = [...dataTable];
    const item = { ...itens[idxConsulta], status: statusAtendimento(true) };
    itens[idxConsulta] = item;
    setDataTable(itens);
  };

  const iniciarAtendimento = async (idConsultaSolicitacao, status) => {
    if (status === 'Finalizar') return true;
    if (consultaAtendimento === idConsultaSolicitacao) return false;

    setConsultaAtendimento(idConsultaSolicitacao);

    const idxConsulta = dataTable.findIndex(
      x => x.key === idConsultaSolicitacao
    );
    const detalhes = await postIniciarAtendimentoConsultaExterna({
      id: idConsultaSolicitacao,
    });
    if (detalhes?.motorista) {
      atualizaStatusConsultaFinalizar(idxConsulta);
    }
    return true;
  };

  useEffect(() => {
    initialData();
  }, [dateRange, inicializarTela]);

  useEffect(() => {
    formatColumns();
  }, []);

  useEffect(() => {
    inputFilter();
  }, [inputBusca, dataTable]);

  useEffect(() => {
    const isAdmin = temPermissao(['MenuAtendimentoExterno']);
    setIsAdm(isAdmin);
  }, [temPermissao]);

  return (
    <S.Container>
      <Row>
        <S.ContainerFilter>
          <Input
            placeholder="Buscar"
            size="large"
            prefix={<SearchOutlined style={{}} />}
            onChange={e => setInputBusca(e.target.value)}
          />
        </S.ContainerFilter>
      </Row>
      <Row>
        <S.ContainerTable>
          <S.TableCustom
            columns={columnsTable}
            dataSource={dataRender ?? dataTable}
            pagination={false}
            expandable={{
              expandRowByClick: true,
              expandIcon: ({ expanded, onExpand, record }) =>
                expanded ? (
                  <DownOutlined onClick={e => onExpand(record, e)} />
                ) : (
                  <RightOutlined onClick={e => onExpand(record, e)} />
                ),
              expandedRowRender: record => (
                <IniciarAtendimentoConsulta
                  record={record}
                  funcIniAtendimento={iniciarAtendimento}
                />
              ),
            }}
          />
        </S.ContainerTable>
      </Row>
    </S.Container>
  );
}
